export const KYC_STATUS_FAILED = {
  NameFailed: 'name',
  DOBFailed: 'date_of_birth',
  AddressFailed: 'address',
  SSNFailed: 'social_security_number',
  GeneralFailed: 'general',
  IDFailed: 'employer_id_number'
};

export const WALLET_STATUS = {
  Pending: 'pending',
  Failed: 'failed',
  Success: 'passed'
};

export const DEFERRED_TRANSACTION_STATUS = {
  Pending: 'pending',
  Canceled: 'canceled',
  Processed: 'processed'
};

export const walletFailedStatus = [
  'review',
  'failed',
  'documents_required',
  'member_failed',
  'member_review'
];

export const checkIsStatusFailed = (status) =>
  walletFailedStatus.includes(status);

export const PERSONAL_DOCUMENT_LIST = {
  [KYC_STATUS_FAILED.NameFailed]: [
    'id_drivers_license',
    'id_drivers_permit',
    'id_state',
    'id_passport_card',
    'id_passport',
    'vtl_divorce',
    'vtl_marriage',
    'doc_name_change',
    'doc_ss_card',
    'tax_w2'
  ],
  [KYC_STATUS_FAILED.DOBFailed]: [
    'id_drivers_license',
    'id_drivers_permit',
    'id_state',
    'id_passport',
    'id_passport_card',
    'vtl_birth_certificate'
  ],
  [KYC_STATUS_FAILED.AddressFailed]: [
    'id_drivers_license',
    'id_drivers_permit',
    'id_state',
    'id_military',
    'doc_utility',
    'doc_lease',
    'doc_mortgage',
    'id_nyc_id',
    'doc_tuition'
  ],
  [KYC_STATUS_FAILED.SSNFailed]: [
    'id_drivers_license',
    'id_drivers_permit',
    'id_state',
    'id_passport',
    'id_passport_card',
    'vtl_birth_certificate',
    'doc_ss_card',
    'tax_1040',
    'tax_1099',
    'tax_W4',
    'tax_1095',
    'doc_paystub',
    'doc_ssa',
    'id_military',
    'id_military_dependent',
    'doc_uo_benefits',
    'doc_name_change',
    'vtl_divorce'
  ],
  [KYC_STATUS_FAILED.GeneralFailed]: [
    'id_drivers_license',
    'id_drivers_permit',
    'id_state',
    'id_military',
    'id_military_dependent',
    'id_passport',
    'id_passport_card'
  ]
};

export const ROLE_MEMBERS = {
  administrator: 'Administrator',
  beneficial_owner: 'Beneficial owner',
  controlling_officer: 'Company Owner'
};

export const LIST_ROLE_MEMBERS = [
  { value: 'administrator', title: 'Administrator' },
  { value: 'beneficial_owner', title: 'Beneficial owner' },
  { value: 'controlling_officer', title: 'Company Owner' }
];

export const LIST_ROLE_MEMBERS_BO = [
  { value: 'beneficial_owner', title: 'Beneficial owner' },
  { value: 'administrator', title: 'Administrator' }
];

export const TransferStatus = {
  Pending: 'pending',
  Send: 'send',
  Receive: 'receive'
};

export const WALLET_ACCESS_ROLE = {
  OWNER: 'OWNER',
  ADMIN: 'administrator',
  BENEFICIAL_OWNER: 'beneficial_owner',
  CONTROLLING_OFFICER: 'controlling_officer',
  CONTRACTOR_PRODUCER: 'CONTRACTOR',
  BUSINESS_MEMBER: 'BUSINESS MEMBER'
};

// START Document requirements
const addressRequirements = [
  'Clear photos and PDFs are fine; we cannot accept screenshots or scans.',
  'All documents must be current. IDs cannot be expired, and monthly bills or statements should have been issued within the past 60 days.',
  'We need to see all four corners of the document, and the information we need to verify must be clearly visible.',
  "If you're using a photo ID, please send us images of both the front and the back.",
  'If the document has a signature requirement, then it must be hand-signed. We cannot accept electronic signatures (with the exception of leases, where electronic signatures are acceptable).',
  'Government-issued documents (such as a state-issued ID or passports) must be in color. We can accept black-and-white photos or PDFs of other documents, such as utility bills.'
];

const DOBRequirements = [
  'We can only accept clear color photos; we cannot accept scans.',
  'We need to see all four corners of the document, and the name you are verifying must be clearly visible.'
];

const nameRequirements = [
  'We can only accept clear color photos; we cannot accept scans.',
  'We need to see all four corners of the document, and the name you are verifying must be clearly visible.'
];

const SSNRequirements = [
  'The user must provide images of the front and back of each document they submit',
  'We can only accept clear color photos; we cannot accept scans or copies.',
  'We need to see all four corners of the document, and everything must be human readable.'
];

const generalRequirements = [
  'Clear photos only; we cannot accept screenshots or scans.',
  'All documents must be current. IDs cannot be expired.',
  'We need to see all four corners of the document, and the information we need to verify must be clearly readable.',
  'Send us images of both the front and the back of the document.',
  'If the document has a signature requirement, then it must be hand-signed. We cannot accept electronic signatures (with the exception of leases, where electronic signatures are acceptable).',
  'Government-issued documents (such as a state-issued ID or passports) must be in color. We can accept black-and-white photos or PDFs of other documents, such as utility bills.'
];
// END Document requirements

// Start Document guides
const addressDocumentGuide = [
  'Utility bill dated within the past 60 days (please note: we cannot accept mobile phone bills, but we can accept internet or landline bills)',
  'Lease agreement (Negotiated within the past year; month-to-month leases must be negotiated within the past 6 months. Leases must include the terms and be signed by both the lessor and lessee.)',
  'Signed mortgage agreement (signed, and dated within the last 60 days)',
  'NYC ID card',
  'Tuition statement (for college or university students only; must include your dorm address, the date, and the school contact information)'
];

const nameDocumentGuide = [
  'A current, signed U.S. passport or a U.S. passport card (first and second page of passport, or front and back of card)',
  'A marriage license or divorce decree (this must have your new legal name printed by the state, and it must show that a name change occurred)',
  'A court order for the name change',
  'A Social Security card (front and back)',
  'An IRS form W-2'
];

const generalDocumentGuide = [
  'Obtain a clear selfie from your individual user. The Selfie should include a clear photo of their face and the document of their choice. In other words, the user should hold up their document near their face such that a selfie clearly captures both their face and the document.'
];
// END Document guides
// START Document list
const addressDocumentList = [
  "State-issued driver's license",
  "Driver's permit",
  'State ID card',
  'Military ID'
];

const nameDocumentList = [
  "A current driver's license (front and back)",
  "A current driver's permit with a photo (front and back)",
  'A current state photo ID card (front and back)'
];

const DOBDocumentList = [
  "State Driver's License (front and back, not expired, with photo, and not temporary)",
  "Driver's Permit (front and back, not expired, with photo)",
  'State ID Card (front and back, not expired, with photo)',
  "Please note: we're not able to accept temporary IDs",
  'US Passport (first and second page, not expired, photo page, signature visible)',
  'US Passport Card (front and back, not expired)',
  'Birth Certificate'
];

const generalDocumentList = [
  "State-issued driver's license",
  "Driver's permit",
  'State ID card',
  'Military ID',
  'Passport (both pages)'
];

const SSNDocumentList = [
  [
    "State Driver's License (front and back, not expired, with photo, and not temporary)",
    "Driver's Permit (front and back, not expired, with photo)",
    "State ID Card (front and back, not expired, with photo) <br/>Please note: we're not able to accept temporary IDs",
    'US Passport (first and second page, not expired, photo page, signature visible)',
    'US Passport Card (front and back, not expired)',
    'Birth Certificate'
  ],
  [
    'Social Security Card (front and back)',
    '1040 Tax Return, federal or state versions acceptable (must be the most recent calendar year)',
    'W2 and/or 1099s, includes 1099 MISC, 1099G, 1099R, 1099SSA, 1099DIV, 1099S, 1099INT (must be the most recent calendar year)',
    'W4 Withholding Allowance Certificate, federal or state versions acceptable.',
    '1095, includes: 1095A, 1095B, 1095C (must be the most recent calendar year)',
    'Pay stub documentation (must be the most recent month)',
    'Social Security Administration documentation (includes 4029)',
    {
      title: 'Military records:',
      data: [
        'U.S. Military ID card (front and back)',
        'Military dependent’s ID card (front and back)'
      ]
    },
    'Unemployment Benefits (Unemployment Benefits Letter)',
    'Court Order Granting a Name Change, that must have your original first and last name, new first and last name, and SSN',
    'Divorce decree'
  ]
];
// END Document list

export const MODAL_DATA = {
  [KYC_STATUS_FAILED.NameFailed]: {
    title: 'ID Verification - Name Verification',
    subTitle: 'Name Verification or Update',
    instruction:
      "You fail ID Verification because of your name. If you legally changed your name, we'll need to update the name in our databases as well. The following is a list of documents we can accept to verify or update your user's name.",
    explainDoc: 'A clear photo of one of the following documents:',
    warning: "Please note: we're not able to accept temporary IDs",
    documentRequirements: nameRequirements,
    documentsGuide: nameDocumentGuide,
    documentList: nameDocumentList
  },
  [KYC_STATUS_FAILED.DOBFailed]: {
    title: 'ID Verification - Date of Birth',
    subTitle: 'Date of Birth Verification',
    instruction:
      'If you type in or select the wrong birth date while on-boarding you will fail our ID Verification check and thus need to provide verification of your date of birth. The following is a list of documents we can accept to verify your date of birth.',
    explainDoc: 'A clear photo of one of the following documents:',
    documentRequirements: DOBRequirements,
    documentList: DOBDocumentList
  },
  [KYC_STATUS_FAILED.AddressFailed]: {
    title: 'ID Verification - Individual Address Verification Failed',
    subTitle: 'Address Verification',
    instruction:
      'Please upload one document with the users complete current residential address from the following list.',
    explainDoc: 'The front and back of a current photo ID, such as a:',
    warning:
      "Please note: we're not able to accept temporary IDs, and P.O. Boxes.",
    documentRequirements: addressRequirements,
    documentsGuide: addressDocumentGuide,
    documentList: addressDocumentList
  },
  [KYC_STATUS_FAILED.SSNFailed]: {
    title: 'ID Verification - SSN Verification Failed',
    subTitle: 'SSN Verification',
    instruction:
      'If you type in the wrong SSN while on-boarding you will fail our ID Verification check and thus need to provide verification of your SSN. The following is a list of documents we can accept to verify or update your SSN.',
    documentRequirements: SSNRequirements,
    documentList: SSNDocumentList
  },
  [KYC_STATUS_FAILED.GeneralFailed]: {
    title: 'ID Verification - General Identity Verification',
    subTitle: 'General Identity Verification',
    instruction:
      'You have to upload 2 documents. You must send in a photo selfie holding your ID document, as well as a clear and readable photo of your ID document.',
    explainDoc:
      'Request one document from the list below.\nThe front and back of a current photo ID, such as a:',
    warning: "Please note: we're not able to accept temporary IDs",
    documentRequirements: generalRequirements,
    documentsGuide: generalDocumentGuide,
    documentList: generalDocumentList
  }
};

export const INFO_MESSAGES_DATA = {
  [KYC_STATUS_FAILED.NameFailed]: {
    title: 'Adding a name to your account',
    text: 'To add a former name, users can send us a birth certificate or a court order for the name change.'
  },
  [KYC_STATUS_FAILED.GeneralFailed]: {
    title: 'Document Upload Options',
    text: 'Front and Back images of ID documents can be uploaded together in one document or separately.'
  }
};
